var hs = hs || {};

/**
 * 轮播效果，依赖 swiper2 插件
 * wrapper: 入口层
 * container: string, swiper实例层, ".swiper-container"
 * pagination: boolean, 是否需要生成分页器(true)
 * paginationClass: string, 分页层, ".swiper-pagination"
 * prevClass: string, prev按钮, ".swiper-prev"
 * nextClass: string, next按钮, ".swiper-next"
 * slideMode: string, 滑动方向, 可设置水平(horizontal)或垂直(vertical)
 * perView: number, 一次显示slides数目(1)
 * perGroup: number, 多少个slides为一组切换(1)
 * autoplay: number, 自动切换的时间间隔(3000)
 * speed: number, 自动滑动开始到结束的时间(300)
 * loop: boolean, 是否循环切换(true)
 * keyboardControl: boolean, 是否开启键盘控制(false)
 * mousewheelControl: boolean, 是否开启鼠标控制(false)
 */

hs.swiper2 = function(param) {
    // 配置
    if (this instanceof hs.swiper2) {
        param = param || {};
        this.wrapper = param.wrapper;
        this.container = param.container || '.swiper-container';
        this.pagination = (typeof param.pagination !== 'undefined') ? param.pagination : true;
        this.paginationClass = param.paginationClass || '.swiper-pagination';
        this.prevClass = param.nextClass || ".swiper-prev";
        this.nextClass = param.nextClass || ".swiper-next";
        this.slideMode = param.slideMode || 'horizontal';
        this.perView = param.perView || 1;
        this.perGroup = param.perGroup || 1;
        this.autoplay = (typeof param.autoplay !== 'undefined') ? param.autoplay : 3000;
        this.speed = param.speed || 300;
        this.loop = (typeof param.loop !== 'undefined') ? param.loop : true;
        this.loopedSlides = param.loopedSlides || 1;
        this.calculateHeight = (typeof param.calculateHeight !== 'undefined') ? param.calculateHeight : false;
        this.keyboardControl = (typeof param.keyboardControl !== 'undefined') ? param.keyboardControl : false;
        this.mousewheelControl = (typeof param.mousewheelControl !== 'undefined') ? param.mousewheelControl : false;
        this.simulateTouch = (typeof param.simulateTouch !== 'undefined') ? param.simulateTouch : false;

        // 操作
        var _this = this;

        var $wrapper = $(_this.wrapper),
            $container = $wrapper.find(_this.container),
            $prev = $wrapper.find(_this.prevClass),
            $next = $wrapper.find(_this.nextClass);

        var mySwiper = $container.swiper({
            mode: _this.slideMode,
            autoplayDisableOnInteraction: true,
            loop: _this.loop,
            loopedSlides: _this.loopedSlides,
            slidesPerView: _this.perView,
            slidesPerGroup: _this.perGroup,
            calculateHeight: _this.calculateHeight,
            speed: _this.speed,
            autoplay: _this.autoplay,

            createPagination: _this.pagination,
            paginationClickable: true,
            pagination: $wrapper.find(_this.paginationClass)[0],
            paginationElement: 'span',
            paginationElementClass: 'swiper-pagination-switch',
            paginationActiveClass: 'swiper-active-switch',
            paginationVisibleClass: 'swiper-visible-switch',
            keyboardControl: _this.keyboardControl,
            mousewheelControl: _this.mousewheelControl,
            simulateTouch: _this.simulateTouch
        });

        var slideLength = mySwiper.slides.length;

        // 非循环模式下prev next可用状态
        function pagerEnable() {
            if (!_this.loop) {
                if (mySwiper.activeIndex === 0) {
                    $prev.addClass('swiper-pager_disable');
                }
                if (mySwiper.activeIndex > 0) {
                    $prev.removeClass('swiper-pager_disable');
                }
                if (mySwiper.activeIndex + _this.perView === slideLength) {
                    $next.addClass('swiper-pager_disable');
                }
                if (mySwiper.activeIndex + _this.perView < slideLength) {
                    $next.removeClass('swiper-pager_disable');
                }
            }
        }
        pagerEnable();

        if (_this.pagination) {
            var $pagination = $wrapper.find(_this.paginationClass);
            $pagination.children('.swiper-pagination-switch').hover(function() {
                mySwiper.swipeTo($(this).index());
                pagerEnable();
            });
        }

        if ($prev.length) {
            $prev.on({
                click: function(e) {
                    e.preventDefault();
                    mySwiper.swipePrev(false);
                    pagerEnable();
                },
                mouseenter: function() {
                    mySwiper.stopAutoplay();
                },
                mouseleave: function() {
                    mySwiper.startAutoplay();
                }
            });
        }
        if ($next.length) {
            $next.on({
                click: function(e) {
                    e.preventDefault();
                    mySwiper.swipeNext(false);
                    pagerEnable();
                },
                mouseenter: function() {
                    mySwiper.stopAutoplay();
                },
                mouseleave: function() {
                    mySwiper.startAutoplay();
                }
            });
        }
        $(window).resize(function() {
            mySwiper.reInit();
        });
        return mySwiper;
    } else {
        return new hs.swiper2(param);
    }
};